import Table from '@tiptap/extension-table'

const CustomTable = Table.extend({
    addAttributes(){
      return {
        ...this.parent?.(),
        class: {
          default: '',
        }
      }
    },
    addCommands(){
      return {
        ...this.parent?.(),
        addClassName: (className) => ({ commands }) => {
          return commands.updateAttributes('table', { class: className })
        },
        removeClassName: (className) => ({ commands }) => {
          return commands.updateAttributes('table', { class: '' })
        }
      }
    }
  })

  export default CustomTable